export enum Stage {
	offer = 'Offer',
	dueDiligence = 'Due Diligence',
	siteVisit = 'Site Visit',
	prospects = 'Prospect',
	lead = 'Lead',
}
export enum OfficerRoles {
	loanOfficer = 'Loan Officer',
	branch = 'Branch',
}

export enum OfficeTypes {
	singleLocation = 'Single Location',
	distributed = 'Distributed',
}

export enum PaymentMethods {
	bps = 'bps',
	flatFee = 'Flat fee',
	other = 'Other',
}

export enum AuditActionTypes {
	add = 'Add',
	change = 'Change',
	remove = 'Remove',
}
